
export default [
  {
    path: '/admin/expense-categories',
    name: 'expense-category',
    meta: { requiresAuth: true },
    component: () => import('@/pages/expense/category')
  }
]
